import React, { useEffect, useRef, useState } from "react";

import { Input } from "../Input/Input";
import { IconType } from "../Icon/Icon";
import { useDebounce } from "src/hooks";

interface Props {
  placeholder?: string;
  width?: string;
  isBorderless?: boolean;
  isFocusedAutomatically?: boolean;
  rightIcon?: { name: IconType; onClick?: () => void } | false;
  onSearch: (search: string) => void;
  refSearch?: React.RefObject<HTMLInputElement>;
  isDisabled?: boolean;
}

export const SearchUncontrolled = ({
  placeholder = "Search",
  width,
  isBorderless,
  isFocusedAutomatically,
  rightIcon,
  onSearch,
  refSearch: refSearchForwarded,
  isDisabled,
}: Props) => {
  const refSearch = useRef<HTMLInputElement>(null);

  const [search, setSearch] = useState("");
  const firstRenderRef = useRef(true);
  const lastSearchRef = useRef("");
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    if (debouncedSearch !== lastSearchRef.current) {
      lastSearchRef.current = debouncedSearch;
      onSearch(debouncedSearch);
    }
  }, [debouncedSearch, onSearch]);

  const getRef = () => {
    return refSearchForwarded || refSearch;
  };

  const clearSearch = () => {
    if (isDisabled) return;
    setSearch("");
    if (lastSearchRef.current !== "") {
      lastSearchRef.current = "";
      onSearch("");
    }
    getRef().current?.focus();
  };

  return (
    <Input
      value={search}
      setValue={setSearch}
      placeholder={`${placeholder}`.replaceAll(".", "") + "..."}
      width={width}
      isBorderless={isBorderless}
      isFocusedAutomatically={isFocusedAutomatically}
      isDisabled={isDisabled}
      leftIcon={{ name: "search" }}
      rightIcon={
        (search && { name: "clear", onClick: isDisabled ? undefined : clearSearch }) || rightIcon
      }
      refInput={refSearchForwarded || refSearch}
    />
  );
};
